import { CobaltClickableTile } from '@cae/cobalt-react/components/tile';
import { CobaltIconInfoCircleSolid } from '@cae/cobalt-react/icons/solid/CobaltIconInfoCircleSolid';
import { CobaltIconWarningMajorSolid } from '@cae/cobalt-react/icons/solid/CobaltIconWarningMajorSolid';
import * as React from 'react';

import type { AlertTileProps } from './AlertTile.types';

import styles from './AlertTile.module.css';
import { ALERT_TILE_TEST_ID, VARIANT_ICON_CLASS_MAP } from './AlertTile.utils';

const AlertTile = React.memo(
  ({
    count,
    label,
    variant,
    onClick,
  }: Readonly<AlertTileProps>): React.ReactElement => {
    const IconComponent =
      variant === 'info'
        ? CobaltIconInfoCircleSolid
        : CobaltIconWarningMajorSolid;

    return (
      <CobaltClickableTile
        data-testid={ALERT_TILE_TEST_ID}
        className={styles.tile}
        onClick={onClick}
      >
        <div className={styles.tileHeader}>
          <p className={`heading-06 ${styles.count}`}>{count}</p>
          <IconComponent
            className={styles[VARIANT_ICON_CLASS_MAP[variant]]}
            size="medium"
            aria-hidden="true"
          />
        </div>

        <p className={`body-02 ${styles.label}`}>{label}</p>
      </CobaltClickableTile>
    );
  }
);

AlertTile.displayName = 'AlertTile';

export { AlertTile };
